export default __webpack_public_path__ + "static/media/marker-icon-yellow.47ad0e76.png";